const changedValue = (details, fieldName) => {
    const change = (details?.changedPrograms ?? details?.ChangedPrograms ?? [])
        .find(item =>
            (item.changedField ?? item.ChangedField) === fieldName
        );
    return change?.newValue ?? change?.NewValue;
};

export const createChangeStatusModel = () => ({
    institutionId: null,
    programId: null,
    action: null,
    suspensionType: null,
    teachoutFlag: null,
    allStudentsTaughtOut: null,
    comments: '',
});

export const createChangeStatusEditModel = details => {
    const teachout = details?.teachoutFlag ??
        changedValue(details, 'Teach-out Required');
    const allTaughtOut = details?.allStudentsTaughtOut ??
        changedValue(details, 'All Students Taught Out');

    return {
        institutionId: details?.institutionId ?? null,
        programId: Number(details?.programID ?? details?.programId) || null,
        action: details?.changeStatusAction ??
            changedValue(details, 'Change Status Action') ?? null,
        suspensionType: details?.suspensionType ??
            changedValue(details, 'Suspension Type') ?? null,
        teachoutFlag:
            typeof teachout === 'boolean' ? teachout :
                teachout === 'Yes' ? true : teachout === 'No' ? false : null,
        allStudentsTaughtOut:
            typeof allTaughtOut === 'boolean' ? allTaughtOut :
                allTaughtOut === 'Yes' ? true : allTaughtOut === 'No' ? false : null,
        comments: '',
    };
};

export const toCreateChangeStatusRequest = form => {
    const suspendedPathResolvesToElimination =
        form.action === 'Suspending' &&
        form.suspensionType === 'Suspended' &&
        (form.teachoutFlag === false || form.allStudentsTaughtOut === true);
    const action = suspendedPathResolvesToElimination
        ? 'Eliminating'
        : form.action;
    const hasTeachoutAnswers =
        form.action === 'Eliminating' ||
        (form.action === 'Suspending' && form.suspensionType === 'Suspended');

    return {
        institutionId: form.institutionId,
        programId: form.programId,
        action,
        suspensionType: action === 'Suspending' ? form.suspensionType : null,
        teachoutFlag: hasTeachoutAnswers ? form.teachoutFlag : null,
        allStudentsTaughtOut:
            hasTeachoutAnswers && form.teachoutFlag === true
                ? form.allStudentsTaughtOut
                : null,
        comments: form.comments.trim() || null,
    };
};

export const toEditChangeStatusRequest = (form, details) => {
    return {
        ...toCreateChangeStatusRequest(form),
        requestId: details?.requestID ?? details?.requestId,
    };
};
